import '../../../../assets/alfa-font.css';
import '../../assets/third-party-css/index.css';
import { BrandDescriptor, ModuleDescriptor } from './brand-loader';
import { alfaTheme } from '../../styles/alfa/alfa-theme';

const alfaModules: ReadonlyArray<ModuleDescriptor> = Object.freeze([
  {
    externalName: 'WelcomeTextWidget',
    entryPoint: async () => {
      await import('../../../welcome-text/common/common-welcome-text-widget');
      return import('../../../welcome-text/alfa/alfa-welcome-text-widget').then((wtw) => wtw.WelcomeTextWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'CarSearchWidget',
    entryPoint: async () => {
      await import('../../components/input/slider/general/slider-common');
      await import('../../../car-search-widget/common/common-car-search-widget');
      return import('../../../car-search-widget/alfa/alfa-car-search-widget').then((csw) => csw.CarSearchWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Webform',
    entryPoint: async () => {
      await import('dompurify');
      await import('classnames');
      await import('resize-observer-polyfill');
      await import('../../../location/common/common-location');
      await import('../../../common-form-widget/common-form-index-widget');
      return import('../../../common-form-widget/alfa/alfa-common-form-widget').then(
        (form) => form.AlfaCommonFormWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Location',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      return import('../../../location/alfa/alfa-location').then((loc) => loc.AlfaLocationPage);
    },
    labelPrefix: 'location',
  },
  {
    externalName: 'Showroom',
    entryPoint: async () => {
      await import('dompurify');
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/alfa/alfa-showroom').then((showroom) => showroom.AlfaShowroomComponent);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'ModShowroom',
    entryPoint: async () => {
      await import('dompurify');
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/alfa/v2/alfa-showroom_v2').then((showroom) => showroom.AlfaShowroomV2Component);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'FooterWidget',
    entryPoint: async () => {
      return import('../../../footer/alfa/alfa-footer-widget').then((footer) => footer.FooterWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'BannerWidget',
    entryPoint: async () => {
      return import('../../../banner/alfa/alfa-banner-widget').then((banner) => banner.AlfaBannerWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'CatwalkWidget',
    entryPoint: async () => {
      return import('../../../catwalk-widget/alfa/alfa-catwalk-widget').then((banner) => banner.AlfaCatwalkWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'VACS',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../components/input/slider/general/slider-common');
      await import('../../../vacs/common/common-vacs');
      return import('../../../vacs/alfa/alfa-vacs').then((vacs) => vacs.VACS);
    },
    labelPrefix: 'vacs',
  },
  {
    externalName: 'StandardProWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../../standard-pro-widget/alfa/alfa-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/alfa/alfa-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/alfa/alfa-standard-pro-banner-widget');
      return import('../../../standard-pro-widget/alfa/alfa-standard-pro-widget').then(
        (spw) => spw.AlfaStandardProWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/alfa/alfa-standard-pro-text-widget').then(
        (spw) => spw.AlfaStandardProWidgetText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetBanner',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/alfa/alfa-standard-pro-banner-widget').then(
        (spw) => spw.AlfaStandardProWidgetBanner
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetDownloads',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/alfa/alfa-standard-pro-downloads-widget').then(
        (spw) => spw.AlfaStandardProWidgetDownloads
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetGallery',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/alfa/alfa-standard-pro-gallery-widget').then(
        (spw) => spw.AlfaStandardProWidgetGallery
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/alfa/alfa-standard-pro-image-and-text-widget').then(
        (spw) => spw.AlfaStandardProWidgetImageAndTextWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetMultipleImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/alfa/alfa-standard-pro-multi-image-and-text-widget').then(
        (spw) => spw.AlfaStandardProWidgetMultiImageAndText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTable',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/alfa/alfa-standard-pro-table-widget').then(
        (spw) => spw.AlfaStandardProWidgetTable
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetVideo',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/alfa/alfa-standard-pro-video-widget').then(
        (spw) => spw.AlfaStandardProWidgetVideo
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTabs',
    entryPoint: async () => {
      await import('../../../standard-pro-widget/alfa/alfa-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/alfa/alfa-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/alfa/alfa-standard-pro-banner-widget');
      await import('../../../standard-pro-widget/alfa/alfa-standard-pro-video-widget');
      return import('../../../standard-pro-widget/alfa/alfa-standard-pro-tabs-widget').then(
        (spw) => spw.AlfaStandardProWidgetTabs
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'OfferWidget',
    entryPoint: async () => {
      await import('../../../offer-widget/common/common-offer-widget');
      return import('../../../offer-widget/alfa/alfa-offer-widget').then((ow) => ow.AlfaOfferWidgetComponent);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'TestPageWidget',
    entryPoint: async () => {
      return import('../../../test-page/alfa/alfa-test-page-widget').then((tpw) => tpw.TestPageWidget);
    },
    labelPrefix: 'widget',
  },
]);

export default [alfaModules, alfaTheme] as BrandDescriptor;
